module.exports = "/_next/static/images/d8cf1a72dc57b43e1dbc0275fdab1e64-hero.svg.webp";